import { Icon } from '@hologram-dimension/icon';
import { type FC } from 'react';
import styles from './PanelSection.module.css';
import type { ComplexPanelSectionProps } from './shared';

const ComplexPanelSection: FC<Omit<ComplexPanelSectionProps, 'variant'>> = ({
  heading,
  headingIcon,
  fieldGroup,
  notes,
  actions,
}) => (
  <div className={styles.complexWrapper}>
    <div className={styles.heading}>
      {headingIcon && (
        <div className={styles.icon}>
          <Icon name={headingIcon} size="medium" fill="currentColor" />
        </div>
      )}
      <span>{heading}</span>
    </div>
    <div className={styles.fieldGroup}>{fieldGroup}</div>
    {(notes || actions) && (
      <div className={styles.aside}>
        {notes && <div className={styles.notes}>{notes}</div>}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    )}
  </div>
);

export default ComplexPanelSection;
